export enum ELogLevel {
    Trace,
    Info,
    Warn,
    Debug,
    Error
} 